import React from 'react'

export const initialState = {
    progress:0,
    color:"red",
    height:2
};

// https://blog.liplex.de/axios-interceptor-to-refresh-jwt-token-after-expiration/

export const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_TO_LOADING":
        return {
            ...state,
            progress: action.payload
        }
    case "COMPLETE":
        return {
            ...state,
            progress: 0
        } 
    default:
      return state;
  }
};

const LoadingContext = React.createContext(initialState);

export const LoadingProvider = LoadingContext.Provider
export const LoadingConsumer = LoadingContext.Consumer
export default LoadingContext